/* eslint-disable @typescript-eslint/no-explicit-any */
import { Tab, Tabs, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { Vocabulary } from "../Utils/Vocabulary";
import Devices from "./Devices";
import Brands from "./Brands";
import DeviceModels from "./DeviceModels";
import Statuses from "./Statuses";
import Workflows from "./Workflows";
import Steps from "./Steps";
import styles from "../Styles/dashboard.module.css";
import theme from "../Themes/Theme";
export default function DevicesMainPage() {
  const [value, setValue] = useState(0);
  const phoneStyle = useMediaQuery("(max-width: 800px)");

  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);
  }

  function showInformation() {
    switch (value) {
      case 0:
        return <Devices />;
      case 1:
        return <Brands />;
      case 2:
        return <DeviceModels />;
      case 3:
        return <Statuses />;
      case 4:
        return <Workflows />;
      case 5:
        return <Steps />;
      default:
        break;
    }
  }
  function getTabStyle(tabValue: number) {
    return {
      backgroundColor:
        value === tabValue
          ? theme.palette.secondary.main
          : theme.palette.cancel?.main,
      color: value === tabValue ? "white" : "#9c9b9b",
      borderTopRightRadius: "10px",
      borderTopLeftRadius: "10px",
      marginRight: "1px",
    };
  }

  return (
    <div
      className={phoneStyle ? styles.mainContainerMobile : styles.mainContainer}
    >
      <div style={{ width: "100%" }}>
        <Tabs value={value} onChange={handleChangeValue} textColor="inherit">
          <Tab label={Vocabulary.devices} style={getTabStyle(0)} />
          <Tab label={Vocabulary.brands} style={getTabStyle(1)} />
          <Tab label={Vocabulary.models} style={getTabStyle(2)} />
          <Tab label={Vocabulary.statuses} style={getTabStyle(3)} />
          <Tab label={Vocabulary.workflows} style={getTabStyle(4)} />
          <Tab label={Vocabulary.steps} style={getTabStyle(5)} />
        </Tabs>
        {showInformation()}
      </div>
    </div>
  );
}
